import { useState, useEffect } from 'react';

const useResponsiveText = (textArray: string[], threshold: number = 10) => {
  const [className, setClassName] = useState(false);

  useEffect(() => {
    const isLongText = textArray.some((text) => text.length > threshold);
    setClassName(isLongText ? true : false);
  }, [textArray, threshold]);

  return className;
};

export default useResponsiveText;
